"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EBDomains = exports.EBEnvs = void 0;
var EBEnvs;
exports.EBEnvs = EBEnvs;

(function (EBEnvs) {
  EBEnvs["PROD"] = "prod";
  EBEnvs["STAGE"] = "stage";
  EBEnvs["QA"] = "qa";
  EBEnvs["DEV"] = "dev";
})(EBEnvs || (exports.EBEnvs = EBEnvs = {}));

var EBDomains;
exports.EBDomains = EBDomains;

(function (EBDomains) {
  EBDomains["EVENTBRITE"] = "eventbrite";
  EBDomains["EVBSTAGE"] = "evbstage";
  EBDomains["EVBQA"] = "evbqa";
  EBDomains["EVBDEV"] = "evbdev";
})(EBDomains || (exports.EBDomains = EBDomains = {}));
//# sourceMappingURL=types.js.map